import React from "react";
import cn from "classnames";

import { getDataTestId } from "src/utils";
import { LapsProps } from "./types";
import { useContent } from "src/hooks";

import styles from "./style.module.scss";

export const useStatusLaps = (props: LapsProps) => {
  const content = useContent();

  const isStarted = props.game.status === "started";
  const isFinished = props.game.status === "finished";

  const getLapsProps = React.useCallback(
    () => ({
      className: cn(styles[content], {
        [styles.padded]: isStarted || isFinished,
      }),
    }),
    [content, isFinished, isStarted]
  );

  const getStartProps = React.useCallback(
    () => ({
      ...getDataTestId("game-status"),
    }),
    []
  );

  const getFinishProps = React.useCallback(
    () => ({
      ...getDataTestId("game-status"),
    }),
    []
  );

  const values = React.useMemo(
    () => ({
      styles,
    }),
    []
  );

  return { getFinishProps, getLapsProps, getStartProps, values };
};
